<template>
  <Field
    as="textarea"
    :name="'remarks' + index"
    :id="'remarks' + index"
    class="block px-4 py-3 min-w-full border rounded resize-none"
    style="line-height: 18px; overflow: auto"
    :style="{ height: `${state.getTextareaHeight()}px` }"
    placeholder="備考欄（相手に公開されます）"
    v-model="state._sectionItem.note"
    @change="updateTmpData()"
  />
</template>

<script>
import { reactive, computed } from 'vue';
import { Field } from 'vee-validate';

export default {
  props: {
    sectionItem: Object,
    index: Number,
  },
  components: {
    Field,
  },
  emits: ['update-tmp-data'],
  setup(props, context) {
    const state = reactive({
      _sectionItem: computed(() => {
        return props.sectionItem;
      }),
      getTextareaHeight: computed(() => {
        return function () {
          let rowCount = `${props.sectionItem.note}\n`.match(/\n/g).length;
          const LINEHEIGHT = 40;
          let lineHeight = LINEHEIGHT + (rowCount - 1) * 18;
          return lineHeight;
        };
      }),
    });

    const updateTmpData = () => {
      for (const item of state._sectionItem.detail_items) {
        if (!item.name || !item.price || !item.quantity) {
          return;
        }
      }
      context.emit('update-tmp-data');
    };

    return {
      state,
      updateTmpData,
    };
  },
};
</script>

<style lang="scss" scoped>
textarea {
  outline: none;
  &:focus {
    border: 1px solid #2cb2b2;
    box-sizing: border-box;
    box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #dde1ed;
    border-radius: 10px;
  }
}
</style>
